import isEmpty from './isEmpty'
import createTempId from './createTempId'
import calcItemTotalEnc from './calcItemTotalEnc'
import getWeaponDamageDice from './getWeaponDamageDice'
//----------------------------------------------
// convert starter items (to character items)
//----------------------------------------------
export default function convertStarterItems(starter_items) {
  console.log('-----------------------')
  console.log('IN convertStarterItems')

  if (isEmpty(starter_items)) {
    return null
  }

  let items = starter_items.map((s) => {
    // init static item fields
    const name = s.name ?? ''
    const type = s.type ?? ''
    const equipment_type = s.equipment_type ?? ''
    const staticItemId = s.id ?? null
    const tallyable = s.tallyable ?? false
    const wearable = s.wearable ?? false
    const storeable = s.storeable ?? false
    const storage = s.storage ?? false
    const attach_point = s.attach_point ?? false
    const attachable = s.attachable ?? false

    const container_capacity = s.container_capacity ?? null
    const container_size_short = s.container_size_short ?? ''
    const container_size_long = s.container_size_long ?? ''
    const container_size = s.container_size ?? ''

    // base ENC from static item
    const encRaw = s.enc ?? 0
    const enc = typeof encRaw === 'string' ? parseFloat(encRaw) : encRaw

    // starting tally for starter items
    const tally_qty = 1

    // mirror frontend helper behaviour for per-item ENC
    const tot_enc = calcItemTotalEnc({ character_item: { enc, tally_qty } })

    // init weapon fields
    const ap = s.ap ?? 0
    const hp = s.hp ?? 0
    const damage_dice = getWeaponDamageDice(s)
    const range = s.range ?? ''
    const load = s.load ?? ''
    const impale = s.impale ?? false
    const set_charge = s.set_charge ?? false
    const useable = s.useable ?? false

    const temp_id = createTempId()

    return {
      character: 0,
      container: null,
      equipment_type: equipment_type,
      id: temp_id,
      item: staticItemId,
      name: name,
      type: type,
      //
      enc: enc,
      tot_enc: tot_enc,
      //
      tally_qty: tally_qty,
      //
      contents_count_direct: 0,
      contents_count_total: 0,
      contents_enc: 0,
      //
      player_notes: '',
      short_description: '',
      //
      runes: [],
      non_runes_spells: [],
      //
      worn_location: null,
      attach_location: null,
      //
      starter: true,
      tallyable: tallyable,
      wearable: wearable,
      storeable: storeable,
      storage: storage,
      attachable: attachable,
      attach_point: attach_point,
      //
      container_capacity: container_capacity,
      container_size_short: container_size_short,
      container_size_long: container_size_long,
      container_size: container_size,
      //
      ap: ap,
      hp: hp,
      damage_dice: damage_dice,
      range: range,
      load: load,
      impale: impale,
      set_charge: set_charge,
      useable: useable,
      unuseable_reason: '',
    }
  })
  return items
}
